export default "__VITE_ASSET__1Yat0JS4__"